/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import { getUserAction, updatePasswordAction } from './actions';
import { Auth } from '../../services/Auth';
import { SagaIterator } from 'redux-saga';
import { GET_USER_REQUEST, ProfileState, UPDATE_PASSWORD_REQUEST } from './types';
import { setAppStateAction } from '../app/actions';

function* handleGetUser(): SagaIterator {
  try {
    // yield put(setAppStateAction({ loading: true, logged: false }));
    // yield put(setAppStateAction({ loading: true }));
    const response = yield call(Auth.getMe);

    const { data } = response;
    const userData: ProfileState = {
      firstName: data.name,
      lastName: data.surname,
      phone: data.phone_number,
      email: data.email,
      isActive: data.is_active,
      pk: data.pk,
    };

    yield put(getUserAction.success({ data: userData }));
    // yield put(setAppStateAction({ loading: false }));
    // yield put(setAppStateAction({ loading: false, logged: true }));
  } catch (error) {
    // yield put(setAppStateAction({ loading: false }));
    console.log(error, 'getUserAction error');
    yield put(setAppStateAction({ loading: false, logged: false }));
  }
}

function* handleUpdatePassword(
  action: ReturnType<typeof updatePasswordAction.request>,
): SagaIterator {
  const { old_password, password, onSuccess, onFailure } = action.payload;
  try {
    yield call(Auth.updatePassword, { old_password, password });
    if (onSuccess) onSuccess();
  } catch (error: any) {
    const errorMessage = error?.response?.data?.detail || 'Ошибка при обновлении пароля.';
    yield put(updatePasswordAction.failure(errorMessage));
    if (onFailure) onFailure(errorMessage);
  }
}

function* userSaga() {
  yield takeLatest(GET_USER_REQUEST, handleGetUser);
  yield takeLatest(UPDATE_PASSWORD_REQUEST, handleUpdatePassword);
}

export default userSaga;
